export default [
  {
    id: 1,
    name: 'Weight',
    type: 'NUMBER',
    units: 'G',
    isNew: true
  }
];
